import JoinRoute from '@/screens/Join/JoinRoute';

export default function TeamJoinRoute() {
  return <JoinRoute kind="team" />;
}
